import React, { Fragment } from 'react'
import { graphql } from 'gatsby'

import { getProject } from '../../projects'
import {
  ProjectLayout,
  ProjectIntro,
  Title,
  Paragraph,
} from '../../layouts/project'

import { useNavbarTheme } from '../../contexts/NavbarTheme'

import { media } from '../../styles/tools'

import { AutoFade, AutoSlide } from '../../components/Animated'
import Wrapper from '../../components/Wrapper'
import Space from '../../components/Space'
import VideoPlayer from '../../components/VideoPlayer'

import Logo from '../../assets/pages/work/fox-digital/Logo.js'
import webroll from '../../assets/pages/work/fox-digital/webroll.mp4'
import video from '../../assets/pages/work/fox-digital/video.mp4'

export const query = graphql`
  {
    headerImage: file(relativePath: { eq: "pages/work/fox-digital.jpg" }) {
      ...windowWide
    }
    facebookImage: file(relativePath: { eq: "pages/work/fox-digital.jpg" }) {
      ...facebookShareImage
    }
    twitterImage: file(relativePath: { eq: "pages/work/fox-digital.jpg" }) {
      ...twitterShareImage
    }
  }
`

let project = getProject('fox-digital')

export default ({ data }) => {
  project = {
    ...project,
    headerImage: data.headerImage.childImageSharp.fluid,
    facebookImage: data.facebookImage.childImageSharp.fixed.src,
    twitterImage: data.twitterImage.childImageSharp.fixed.src,
    logo: <Logo />,
  }

  useNavbarTheme('dark')

  return (
    <ProjectLayout project={project}>
      <ProjectIntro
        project={project}
        css={{ color: '#274ba1' }}
        text={
          <Fragment>
            <AutoFade>
              <Title as="h1" css={{ maxWidth: '11em' }}>
                Engaging TV fans with contagious content
              </Title>
            </AutoFade>
            <Space y={32} />
            <AutoFade>
              <Paragraph>
                Social media isn’t just a second screen for TV watchers; it’s
                the first screen for people who want to dive deeper into their
                favorite FOX TV series. Our challenge was to create emotive buzz
                content outside the confines of a 30- or 60-minute episode –
                where fans could discover exclusive content and engage in
                real-time conversations with the goal of increasing views of
                FOX’s newest hit shows.
              </Paragraph>
            </AutoFade>
          </Fragment>
        }
      >
        <Space y={{ mobile: 60, tablet: 100 }} />
        Intro
      </ProjectIntro>
      <Wrapper>
        <Space y="25vw" />
        <Space y={{ mobile: 80, tablet: 150 }} />
        Content
      </Wrapper>
    </ProjectLayout>
  )
}
